<template>
  <div 
    id="ascii"
    tabindex="-1"
  >
    <table>
      <tbody
        :style="{
          '--height': height + 'px',
          '--width' : width + 'px',
        }"
      >
        <tr
          v-for="row in rows"
          :key="row"
        >
          <td
            v-for="col in cols"
            :key="col"
            @mouseover.stop="trail"
          >
           {{ 
              wspc 
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  name: 'Nomansland',

  data() {
    return {
      wspc: '\u00A0',
      height: 16,
      width: 12,
      asciiHigh: 39,
      asciiLow: 47,
    }
  },

  computed: {
    rows() { return Math.floor(window.innerHeight / this.height) },
    cols() { return Math.floor(window.innerWidth / this.width) },
  },
  
  methods: {

    trail(e) {
      this
      .timeInter(() => e.target.innerHTML = this.randomString(), 80, 10)
      setTimeout(() => e.target.innerHTML = this.wspc, 1050)
      setTimeout(() => e.target.innerHTML = this.wspc, 2000)
    },

    timeInter(callback, interval, repeats) {
      let 
        timer, 
        trigger = () => {
          callback()
          --repeats || clearInterval(timer)
        } 
      interval = interval <= 0 ? 1000 : interval  // default: 1000ms
      repeats  = parseInt(repeats, 10) || 0       // default: repeat forever
      timer    = setInterval(trigger, interval)
      return true
    },

    randomString() {
      return String.fromCharCode(this.randomAscii())
    },

    randomAscii() {
      return Math.floor((Math.random() * (this.asciiHigh - this.asciiLow)) + this.asciiLow)
    },
  }
}
</script>

<style scoped>
#ascii {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  font-size: var(--height);
  font-family: 'Courier New', Courier, monospace;
  font-family: 'Space Grotesk';
  color: var(--color);
  /* z-index: 1; */
  cursor: none;
}
table {
  height: 100vh;
  width: 100vw;
  margin: 0;
  border-collapse: collapse;
  border-spacing: 0;
}
table tr td {
  height: var(--height);
  width: var(--width);
  text-align: center;
  line-height: 0;
  padding: 0;
}
table,
table tr,
table tr td,
table tr td * {
  user-select: none;
}
    
</style>
